export default __webpack_public_path__ + "static/media/payout.618547db.svg";